/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Effort_Cooldown_RunInputs */

const en_ui_effort_cooldown_run = /** @type {(inputs: Ui_Effort_Cooldown_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cool-down`)
};

const de_ui_effort_cooldown_run = /** @type {(inputs: Ui_Effort_Cooldown_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslaufen`)
};

/**
* | output |
* | --- |
* | "Cool-down" |
*
* @param {Ui_Effort_Cooldown_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_effort_cooldown_run = /** @type {((inputs?: Ui_Effort_Cooldown_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Effort_Cooldown_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_effort_cooldown_run(inputs)
	return de_ui_effort_cooldown_run(inputs)
});